package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.doc.ColorRefs
import dev.lingvo.shared.screenshots.doc.Palette
import kotlin.math.roundToInt

/** Resolves colours to ARGB, including cyclic slot accents and multiplicative alpha. */
fun resolveColor(ref: String, palette: Palette, slotIndex: Int): Long {
    require(slotIndex >= 0) { "Slot index must be non-negative" }
    require(ColorRefs.isValid(ref)) { "Invalid colour reference" }
    if (ref.startsWith('#')) return hexArgb(ref)
    val hex = when (ref.substringBefore('/')) {
        "@bg" -> palette.bg
        "@surface" -> palette.surface
        "@ink" -> palette.ink
        "@inkMuted" -> palette.inkMuted
        "@accent" -> palette.accent
        "@accentInk" -> palette.accentInk
        "@slot" -> palette.slotAccents.takeIf { it.isNotEmpty() }?.let { it[slotIndex % it.size] } ?: palette.accent
        else -> throw IllegalArgumentException("Unknown palette token")
    }
    val argb = hexArgb(hex)
    val alpha = ref.substringAfter('/', "1").toDouble()
    val resolvedAlpha = (((argb ushr 24) and 255) * alpha).roundToInt()
    return (argb and 0xFFFFFF) or (resolvedAlpha.toLong() shl 24)
}

private fun hexArgb(hex: String): Long {
    require(ColorRefs.isHex(hex)) { "Palette values must be hexadecimal colours" }
    val rgb = hex.substring(1, 7).toLong(16)
    val alpha = if (hex.length == 9) hex.substring(7, 9).toLong(16) else 255L
    return (alpha shl 24) or rgb
}
